export default function Estetica() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Espelhos e Divisórias */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-20">
          <div className="rounded-2xl overflow-hidden h-[300px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=luxury%20interior%20design%20large%20custom%20mirror%20wall%20panel%20glass%20partition%20office%20home%20modern%20minimal%20elegant%20S%C3%A3o%20Paulo%20premium%20finish&width=900&height=840&seq=est001&orientation=portrait"
              alt="Espelhos e divisórias de vidro"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div>
            <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
              ESTÉTICA E DESIGN
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 leading-tight mb-4">
              Espelhos e Divisórias Internas que Transformam Ambientes
            </h2>
            <p className="text-stone-500 text-sm leading-relaxed mb-6">
              Além do envidraçamento de sacada, a Thelux é especialista em criar ambientes sofisticados com espelhos sob medida e divisórias de vidro que ampliam espaços, trazem luz e elevam o padrão estético de qualquer ambiente.
            </p>
            <ul className="space-y-4">
              {[
                { icon: 'ri-focus-3-line', text: 'Espelhos sob medida com bisotê, lapidação e molduras personalizadas' },
                { icon: 'ri-layout-column-line', text: 'Divisórias de vidro para escritórios, home offices e ambientes residenciais' },
                { icon: 'ri-door-open-line', text: 'Portas de vidro temperado com ferragens premium' },
                { icon: 'ri-palette-line', text: 'Vidros coloridos, jateados e impressos para projetos exclusivos' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-100 text-stone-600 shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <p className="text-stone-600 text-sm leading-relaxed pt-1.5">{item.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Fachadas */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
              FACHADAS COMERCIAIS
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 leading-tight mb-4">
              Fachadas Comerciais com Eficiência Energética
            </h2>
            <p className="text-stone-500 text-sm leading-relaxed mb-6">
              Projetos de fachadas em vidro que combinam estética contemporânea com desempenho energético. Reduza o consumo de ar-condicionado e valorize a identidade visual do seu negócio com soluções em vidro de controle solar.
            </p>
            <ul className="space-y-4">
              {[
                { icon: 'ri-sun-line', text: 'Vidros de controle solar que reduzem o calor interno em até 60%' },
                { icon: 'ri-building-4-line', text: 'Fachadas estruturais e semi-estruturais para edifícios comerciais' },
                { icon: 'ri-leaf-line', text: 'Soluções sustentáveis com certificação de eficiência energética' },
                { icon: 'ri-tools-line', text: 'Projeto, fabricação e instalação com equipe própria especializada' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-100 text-stone-600 shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <p className="text-stone-600 text-sm leading-relaxed pt-1.5">{item.text}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className="order-1 lg:order-2 rounded-2xl overflow-hidden h-[300px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20commercial%20glass%20facade%20building%20S%C3%A3o%20Paulo%20energy%20efficient%20curtain%20wall%20exterior%20architecture%20premium%20contemporary%20design%20solar%20control&width=900&height=840&seq=fach001&orientation=portrait"
              alt="Fachada comercial em vidro"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
